// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bZGVWf {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.CVVyqK {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.tGHSdR {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-1-5);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorOrderFilters/FilterChipGroup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB","sourcesContent":[".section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.label {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-1-5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `bZGVWf`,
	"label": `CVVyqK`,
	"chips": `tGHSdR`
};
module.exports = ___CSS_LOADER_EXPORT___;
